import { Typography, Button } from "../../components"
import "./styles.css";

import routekaartgemeentesbeleidsmedewerkers from '../../assets/documents/library/routekaartgemeentesbeleidsmedewerkers2025.pdf';

export default function RoutekaartGemeentesBeleidsmedewerkers(props) {
    return (
        <div className='container'>
            <Typography type='h1' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Routekaart voor Gemeentes en Beleidsmedewerkers</Typography>
            <div className="button-container">
                <Button 
                    target='_blank' 
                    href={routekaartgemeentesbeleidsmedewerkers} 
                    text={`Klik hier voor onze Routekaart voor gemeentes en beleidsmedewerkers`}
                />  
            </div>
        </div>
    )
}